<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="$t('Modify') + ' ' + $t('a.user')"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">
        <b-form @submit.stop.prevent="onSubmit">
          <b-form-group
              id="firstName-input"
              :label="$t('FirstName')+'*'"
              label-for="firstName-input"
              class="bold-label"
              :invalid-feedback="form.firstName.invalidFeedback"
              :state="form.firstName.state"
          >
            <b-form-input
                id="firstName-input"
                :placeholder="$t('FirstName')"
                v-model="form.firstName.value"
                type="text"
                maxlength="250"
                :state="form.firstName.state"
                required
            ></b-form-input>
          </b-form-group>

          <b-form-group
              id="lastName-input"
              :label="$t('LastName')+'*'"
              label-for="lastName-input"
              class="bold-label"
              :invalid-feedback="form.lastName.invalidFeedback"
              :state="form.lastName.state"
          >
            <b-form-input
                id="lastName-input"
                :placeholder="$t('LastName')"
                v-model="form.lastName.value"
                type="text"
                maxlength="250"
                :state="form.lastName.state"
                required
            ></b-form-input>
          </b-form-group>

          <b-form-group
              id="username-input"
              :label="$t('user.Username')+'*'"
              label-for="username-input"
              class="bold-label"
              :invalid-feedback="form.username.invalidFeedback"
              :state="form.username.state"
          >
            <b-form-input
                id="username-input"
                :placeholder="$t('user.Username')"
                v-model="form.username.value"
                type="email"
                maxlength="250"
                :state="form.username.state"
                required
            ></b-form-input>
          </b-form-group>

          <PasswordCreationField
              :isEdit="true"
              @passwordInfos="getPasswordInfos"
          ></PasswordCreationField>


          <div class="d-flex justify-content-end">
            <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import DateField from "../../components/b122/DateField";
import PasswordCreationField from "../../components/b122/PasswordCreationField";

export default {

  name: 'UserEdit',

  components: {
    BackArrow,
    DateField,
    PasswordCreationField
  },

  data() {
    return {
      userId: this.$route.params.userId,
      form: {
        password: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        firstName:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        lastName:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
        username:
            {
              state: null,
              invalidFeedback: null,
              value: null
            },
      }
    }

  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.fetchUser()
    },

    fetchUser() {
      api
          .get(`/user/${this.userId}`)
          .then(response => {
            this.user = response.data
            this.setInitialValues()
          })
    },

    setInitialValues() {
      this.form.username.value = this.user.username
      this.form.firstName.value = this.user.firstName
      this.form.lastName.value = this.user.lastName
    },

    onSubmit() {
      let data = new FormData()
      data.append('password', this.form.password.value)
      data.append('username', this.form.username.value)
      data.append('firstName', this.form.firstName.value)
      data.append('lastName', this.form.lastName.value)

      api({
        method: 'POST',
        url: `/user/${this.user.id}`,
        data: data
      })
          .then((response) => {
            this.$router.push({
              name: 'UserShow',
              params: {
                userId: this.user.id
              }
            }, () => {
              this.$nextTick(() => {
                this.successToast(this.form.username.value)
              })
            })
          })
          .catch((error) => {
            if (error.response.status === 418) {
              const invalidField = error.response.data.invalidField
              this.form[invalidField]["state"] = false
              this.form[invalidField]["invalidFeedback"] = error.response.data.message
            }
          });
    },

    successToast(username) {
      this.$bvToast.toast(this.$i18n.t('User') + ' "' + username + '" ' + this.$i18n.t('modify'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    getPasswordInfos(state, invalidFeedBack, value) {
      this.form.password.state = state;
      this.form.password.invalidFeedback = invalidFeedBack;
      this.form.password.value = value;
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserEdit.vue